import styled from 'styled-components';

/**
 * Wrapper to make alerts inside the fund name cell be properly spaced.
 */
export const FundInfo = styled.div`
  padding-top: 8px;
`;
